import { loadUserDetailsFromLocalStorage } from '../store';
import { navigateTo } from './utils';

/**
 * Check if user is authenticated and redirect to login if not
 * @param {Object} props - React component props for navigation
 * @param {string} redirectPath - Path to redirect after login (optional)
 * @returns {boolean} - true if user is authenticated, false if redirected to login
 */
export const checkAuthAndRedirect = (props, redirectPath = null) => {
  const userDetails = loadUserDetailsFromLocalStorage();
  
  if (!userDetails) {
    // Store the intended action in localStorage for post-login handling
    if (redirectPath) {
      localStorage.setItem('postLoginRedirect', redirectPath);
    }

    // Redirect to login. Post-login redirect will return the user to redirectPath.
    navigateTo(props, `/login`);
    return false;
  }
  
  return true;
};

/**
 * Handle post-login redirect if user was trying to add to cart
 * @param {Object} props - React component props for navigation
 */
export const handlePostLoginRedirect = (props) => {
  const postLoginRedirect = localStorage.getItem('postLoginRedirect');
  
  if (postLoginRedirect) {
    localStorage.removeItem('postLoginRedirect');
    navigateTo(props, postLoginRedirect);
  }
};

/**
 * Get the current page path for redirect after login
 * @param {Object} props - React component props
 * @returns {string} - Current path
 */
export const getCurrentPath = (props) => {
  const { location } = props;
  return location.pathname + location.search;
}; 